// extracted by mini-css-extract-plugin
module.exports =  {"root":"Y3fshV9Ul3EuAGm9yXZE","instagramIndicator":"VqcSiJlO28MgHOtwQwwA"};